module.exports = __webpack_public_path__ + "static/media/42.06a10456.svg";